// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { change } from 'redux-form'
import { error } from 'react-notification-system-redux'
import { UNCAUGHT_ERROR } from 'errors'
import { AFS_PARAMETERS } from 'redux/modules/interferenceAnalysis/constants'
import { fetchInterferenceDefaultParameterByBand } from 'helpers/api'
import { loadingToggler } from 'redux/modules/loading'
import { parseInterferenceParameter } from 'redux/modules/interferenceAnalysis/helpers'

const setBandParametersToDefault = bandId => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const {
        form,
        interferenceAnalysis,
        projectSummary,
      } = getState()

      const unitType = projectSummary.get('unitType')
      const { bands } = form[AFS_PARAMETERS].values
      const bandsIndexInAFSParametersForm = bands.findIndex(d => d.bandId === bandId)

      const propagationModels = interferenceAnalysis.get('propagationModels')

      // must persist these values through along with the bandId and defaults.
      const {
        interferenceProjectParameterId,
        status,
      } = bands[bandsIndexInAFSParametersForm]

      try {
        const { entity } = await fetchInterferenceDefaultParameterByBand(bandId)

        const updatedInterferenceParameter = {
          // scrub the default data so we get it nice and ready for the redux-form
          ...parseInterferenceParameter(entity, unitType, propagationModels),
          // and pass these values through since they aren't provided from the default data.
          bandId,
          interferenceProjectParameterId,
          status,
        }

        await dispatch(change(
          AFS_PARAMETERS,
          `bands[${bandsIndexInAFSParametersForm}]`,
          updatedInterferenceParameter,
        ))
      } catch (err) {
        console.warn(err)
        dispatch(error({
          autoDismiss: 5,
          message: err.message || UNCAUGHT_ERROR,
          title: `Failed to reset default parameters for band id ${bandId}.`,
        }))
      }
    })
  )
)

export default setBandParametersToDefault
